import React from 'react'
import { MessageSquare, Phone, Globe, BarChart3, Shield, Zap, Clock, Users } from 'lucide-react'

const FeaturesSection = () => {
  const features = [
    {
      icon: MessageSquare,
      title: 'AI Chatbot',
      description: 'Intelligent conversational AI that understands context and provides accurate responses instantly.',
      color: 'blue'
    },
    {
      icon: Phone,
      title: 'Voice Calling Agent',
      description: 'Natural voice interactions with advanced speech recognition and text-to-speech capabilities.',
      color: 'green'
    },
    {
      icon: Globe,
      title: 'Multi-Language Support',
      description: 'Communicate with customers in 50+ languages with real-time translation.',
      color: 'purple'
    },
    {
      icon: BarChart3,
      title: 'Advanced Analytics',
      description: 'Track conversations, measure performance, and gain insights with detailed dashboards.',
      color: 'orange'
    },
    {
      icon: Shield,
      title: 'Enterprise Security',
      description: 'Bank-level encryption, GDPR compliant, and SOC 2 certified for maximum data protection.',
      color: 'red'
    },
    {
      icon: Zap,
      title: 'Instant Integration',
      description: 'Connect with your CRM, helpdesk, and favorite tools in minutes with pre-built integrations.',
      color: 'yellow'
    },
    {
      icon: Clock,
      title: '24/7 Availability',
      description: 'Never miss a customer query. Your AI agents work round the clock without breaks.',
      color: 'indigo'
    },
    {
      icon: Users,
      title: 'Team Collaboration',
      description: 'Seamless handoff to human agents when needed with full conversation context.',
      color: 'pink'
    }
  ]

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-100 text-blue-600',
      green: 'bg-green-100 text-green-600',
      purple: 'bg-purple-100 text-purple-600',
      orange: 'bg-orange-100 text-orange-600',
      red: 'bg-red-100 text-red-600',
      yellow: 'bg-yellow-100 text-yellow-600',
      indigo: 'bg-indigo-100 text-indigo-600',
      pink: 'bg-pink-100 text-pink-600'
    }
    return colors[color] || colors.blue
  }

  return (
    <section data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="68:4" data-component-id="client/src/components/home/FeaturesSection.jsx:68:4" id="features" className="py-20 bg-white">
      <div data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="69:6" data-component-id="client/src/components/home/FeaturesSection.jsx:69:6" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="70:8" data-component-id="client/src/components/home/FeaturesSection.jsx:70:8" className="text-center mb-16">
          <h2 data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="71:10" data-component-id="client/src/components/home/FeaturesSection.jsx:71:10" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Powerful Features for Modern Businesses
          </h2>
          <p data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="74:10" data-component-id="client/src/components/home/FeaturesSection.jsx:74:10" className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything you need to deliver exceptional customer experiences at scale
          </p>
        </div>

        <div data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="79:8" data-component-id="client/src/components/home/FeaturesSection.jsx:79:8" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <div data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="83:14" data-component-id="client/src/components/home/FeaturesSection.jsx:83:14"
                key={index}
                className="bg-white p-6 rounded-xl border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all duration-300 group"
              >
                <div data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="87:16" data-component-id="client/src/components/home/FeaturesSection.jsx:87:16" className={`w-14 h-14 rounded-lg ${getColorClasses(feature.color)} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="88:18" data-component-id="client/src/components/home/FeaturesSection.jsx:88:18" className="w-7 h-7" />
                </div>
                <h3 data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="90:16" data-component-id="client/src/components/home/FeaturesSection.jsx:90:16" className="text-xl font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p data-component-path="client/src/components/home/FeaturesSection.jsx" data-component-line="93:16" data-component-id="client/src/components/home/FeaturesSection.jsx:93:16" className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection